import React from 'react';
import { Link } from 'react-router-dom';
import { portfolioData } from '../mock';
import { ArrowUpRight } from 'lucide-react';

const ArtProjects = () => {
  return (
    <section id="art" className="py-32 bg-black border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-20">
          <span className="text-sm tracking-[0.3em] text-zinc-500 uppercase font-medium mb-4 block">
            Featured Series
          </span>
          <h2 className="text-6xl md:text-7xl font-black text-white tracking-tight">
            Art Projects
          </h2>
          <p className="text-xl text-zinc-500 mt-6 max-w-2xl">
            A curated collection of personal art projects exploring themes of identity, isolation, and creative expression.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {portfolioData.artProjects.map((project, index) => (
            <Link
              to={`/project/${project.slug}`}
              key={project.id}
              className="group cursor-pointer block"
              style={{
                animation: `fade-in-up 0.6s ease-out ${index * 0.1}s both`
              }}
            >
              {/* Image */}
              <div className="relative aspect-video overflow-hidden bg-zinc-900 mb-6">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                {/* "View Project" overlay */}
                <div className="absolute bottom-6 left-6 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                  <span className="text-cyan-400 text-sm font-medium uppercase tracking-wider">
                    View Project →
                  </span>
                </div>
              </div>

              {/* Info */}
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <h3 className="text-3xl md:text-4xl font-black text-white mb-2 group-hover:text-cyan-400 transition-colors tracking-tight uppercase">
                    {project.title}
                  </h3>
                  <p className="text-zinc-500 text-base">{project.description}</p>
                </div>
                <div className="text-zinc-600 group-hover:text-cyan-400 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 mt-2">
                  <ArrowUpRight className="h-6 w-6" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArtProjects;
